import React, { useState, useEffect } from 'react';
import axios from 'axios';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import FlightLandIcon from '@material-ui/icons/FlightLand';
import HotelOutlinedIcon from '@material-ui/icons/HotelOutlined';
import HowToRegOutlinedIcon from '@material-ui/icons/HowToRegOutlined';
import DirectionsBusOutlinedIcon from '@material-ui/icons/DirectionsBusOutlined';
import BrandingWatermarkOutlinedIcon from '@material-ui/icons/BrandingWatermarkOutlined';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import AccessibilityOutlinedIcon from '@material-ui/icons/AccessibilityOutlined';
import ChildCareOutlinedIcon from '@material-ui/icons/ChildCareOutlined';
import Typography from '@material-ui/core/Typography';
import ChildFriendlyOutlinedIcon from '@material-ui/icons/ChildFriendlyOutlined';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField'; 
import FormHelperText from '@material-ui/core/FormHelperText'; 
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware';
import * as RequestCategories from '../../../../magic-strings/request-category';
import CustomSelect from '../custom-select';

const StandaloneOfferForm = ({ handleReloadOffers, reservationRequest }) => {
    const [user] = useState(checkTokenExpirationMiddleware());
    const [offerInclusions, setOfferInclusions] = useState(null);
    const [selectedInclusion, setSelectedInclusion] = React.useState([]);
    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null)
    const errors = {
        serverError: "Error Adding Offer — Try again later!",
        validationError: {
            1: "you must chose at least one offer in one of the offer categories!!"
        }
    };
    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };
    useEffect(() => {
        axios.get("/api/offerinclusion", { headers: headers })
            .then(res => { setOfferInclusions(res.data); })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, []);

    const handleChangeMultiple = (event) => {
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
            if (options[i].selected)
                value.push(options[i].value);
        }
        setSelectedInclusion(value);
    };

    const submitOffer = (event) => {
        event.preventDefault();
        setLoader(true);
        setError(null);

        // validate
        let flightOfferInput = event.target.querySelector("#fl-of input");
        let visaOfferInput = event.target.querySelector("#vi-of input");
        let hotelOfferInput = event.target.querySelector("#ht-of input");
        let registrationOfferInput = event.target.querySelector("#rg-of input");
        let transportationOfferInput = event.target.querySelector("#tr-of input");
        if ((visaOfferInput === null || (visaOfferInput !== null && visaOfferInput.value === "")) &&
            (hotelOfferInput === null || (hotelOfferInput !== null && hotelOfferInput.value === "")) &&
            (flightOfferInput === null || (flightOfferInput !== null && flightOfferInput.value === "")) &&
            (registrationOfferInput === null || (registrationOfferInput !== null && registrationOfferInput.value === "")) &&
            (transportationOfferInput === null || (transportationOfferInput !== null && transportationOfferInput.value === ""))) {
            setLoader(false);
            setError(errors.validationError[1]);
            return;
        }

        let standaloneOfferResource = new FormData();
        let inclusionInputs = event.target.querySelectorAll("#ic-pc input");
        let inclusionTextareas = event.target.querySelectorAll("#ic-pc textarea");
        let exclusionTextareas = event.target.querySelectorAll("#ex-pc textarea");
        let attachFile = event.target.querySelector("#file-attach");
        let standaloneOfferInclusionResources = [];
        for (let i = 0; i < selectedInclusion.length; i++) {
            let offerInclusion = {
                OfferInclusionId: parseInt(selectedInclusion[i])
            }
            standaloneOfferInclusionResources.push(offerInclusion);
        }
        standaloneOfferResource.append("ReservationReqId", reservationRequest.id);
        if (visaOfferInput !== null && visaOfferInput.value !== "")
            standaloneOfferResource.append("ReservationSupVisaOfferId", visaOfferInput.value);
        if (hotelOfferInput !== null && hotelOfferInput.value !== "")
            standaloneOfferResource.append("ReservationSupHotelOfferId", hotelOfferInput.value);
        if (flightOfferInput !== null && flightOfferInput.value !== "")
            standaloneOfferResource.append("ReservationSupFlightOfferId", flightOfferInput.value);
        if (registrationOfferInput !== null && registrationOfferInput.value !== "")
            standaloneOfferResource.append("ReservationSupRegistrationOfferId", registrationOfferInput.value);
        if (transportationOfferInput !== null && transportationOfferInput.value !== "")
            standaloneOfferResource.append("ReservationSupTransportationOfferId", transportationOfferInput.value);
        standaloneOfferResource.append("ReservationSupplierStandaloneOfferInclusionResourcesJson", JSON.stringify(standaloneOfferInclusionResources));
        standaloneOfferResource.append("NoofAdults", parseInt(inclusionInputs[0].value));
        standaloneOfferResource.append("AdultPackagePriceInSingle", parseFloat(inclusionInputs[1].value));
        standaloneOfferResource.append("AdultPackagePriceInDouble", parseFloat(inclusionInputs[2].value));
        if (inclusionInputs[3].value !== "")
            standaloneOfferResource.append("NoofChilds", parseInt(inclusionInputs[3].value));
        if (inclusionInputs[4].value !== "")
            standaloneOfferResource.append("ChildPrice", parseInt(inclusionInputs[4].value));
        if (inclusionInputs[5].value !== "")
            standaloneOfferResource.append("NoofInfants", parseInt(inclusionInputs[5].value));
        if (inclusionInputs[6].value !== "")
            standaloneOfferResource.append("InfantPrice", parseInt(inclusionInputs[6].value));
        standaloneOfferResource.append("InclusionsNotes", inclusionTextareas[0].value);
        standaloneOfferResource.append("PaymentPolicy", exclusionTextareas[0].value);
        standaloneOfferResource.append("CancellationPolicy", exclusionTextareas[1].value);
        standaloneOfferResource.append("FreePolicy", exclusionTextareas[2].value);
        standaloneOfferResource.append("ExclusionsNotes", exclusionTextareas[3].value);
        standaloneOfferResource.append("AttachmentFile", attachFile.files.length < 1 ? null : attachFile.files[0]);
        let headers = {
            "Accept": "application/json",
            "Authorization": `Bearer ${user.Token}`,
            "Content-Type": "multipart/form-data",
            "Content-Encoding": "gzip"
        };
        axios.post(`/api/standaloneoffer`, standaloneOfferResource, { headers: headers })
            .then(res => {
                setSuccess(true);
                setTimeout(() => {
                    setLoader(false);
                    handleReloadOffers();
                }, 750);
            })
            .catch(err => {
                setSuccess(false);
                setError(errors.serverError);
                setTimeout(() => setLoader(false), 750);
            });
    }
    return (
        <>
            <Backdrop className={"backdrop"} open={loader}>
                <CircularProgress color="inherit" />
            </Backdrop>
            {
                reservationRequest.isStandalone === true && (
                    reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Visa) >= 0 ||
                    reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Hotel) >= 0 ||
                    reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Flight) >= 0 ||
                    reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Registration) >= 0 ||
                    reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Transportation) >= 0) ?
                    <>
                        <form onSubmit={submitOffer}>
                            <Grid container spacing={1}>
                                <Grid container item xs={12} spacing={2}>
                                    {
                                        reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Flight) >= 0 &&
                                            reservationRequest.flightOffersResources.length > 0
                                            ?
                                            <Grid item sm={4} md={4} lg={4} id="fl-of">
                                                <CustomSelect
                                                    data={reservationRequest.flightOffersResources}
                                                    label={"Choose Flight Offer"}
                                                    required={false}
                                                    icon={<FlightLandIcon fontSize={"small"} />}
                                                />
                                            </Grid>
                                            : null
                                    }
                                    {
                                        reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Visa) >= 0 &&
                                            reservationRequest.visaOffersResources.length > 0
                                            ?
                                            <Grid item sm={4} md={4} lg={4} id="vi-of">
                                                <CustomSelect
                                                    data={reservationRequest.visaOffersResources}
                                                    label={"Choose Visa Offer"}
                                                    required={false}
                                                    icon={<BrandingWatermarkOutlinedIcon fontSize={"small"} />}
                                                />
                                            </Grid>
                                            : null
                                    }
                                    {
                                        reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Hotel) >= 0 &&
                                            reservationRequest.hotelOffersResources.length > 0
                                            ?
                                            <Grid item sm={4} md={4} lg={4} id="ht-of">
                                                <CustomSelect
                                                    data={reservationRequest.hotelOffersResources}
                                                    label={"Choose Hotel Offer"}
                                                    required={false}
                                                    icon={<HotelOutlinedIcon fontSize={"small"} />}
                                                />
                                            </Grid>
                                            : null
                                    }
                                    {
                                        reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Registration) >= 0 &&
                                            reservationRequest.registrationOffersResources.length > 0
                                            ?
                                            <Grid item sm={4} md={4} lg={4} id="rg-of">
                                                <CustomSelect
                                                    data={reservationRequest.registrationOffersResources}
                                                    label={"Choose Registration Offer"}
                                                    required={false}
                                                    icon={<HowToRegOutlinedIcon fontSize={"small"} />}
                                                />
                                            </Grid>
                                            : null
                                    }
                                    {
                                        reservationRequest.requestApplicableCategories.indexOf(RequestCategories.Transportation) >= 0 &&
                                            reservationRequest.transportationOffersResources.length > 0
                                            ?
                                            <Grid item sm={4} md={4} lg={4} id="tr-of">
                                                <CustomSelect
                                                    data={reservationRequest.transportationOffersResources}
                                                    label={"Choose Transportation Offer"}
                                                    required={false}
                                                    icon={<DirectionsBusOutlinedIcon fontSize={"small"} />}
                                                />
                                            </Grid>
                                            : null
                                    }
                                </Grid>

                                <Grid id="ic-pc" container item xs={12} spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography display="block" variant="subtitle2" gutterBottom>
                                            Inclusion Package
                                        </Typography>
                                    </Grid>

                                    <Grid item sm={12} md={12} lg={12}>
                                        <FormControl>
                                            <InputLabel shrink htmlFor="ic-dt">
                                                Offer Inclusions
                                            </InputLabel>
                                            <Select
                                                multiple
                                                native
                                                className="std-inclusion"
                                                value={selectedInclusion}
                                                onChange={handleChangeMultiple}
                                                inputProps={{
                                                    id: 'ic-dt', style: { minHeight: "300px" }
                                                }}
                                            >
                                                {
                                                    offerInclusions ?
                                                        offerInclusions.map((offerInclusion, index) => (
                                                            <option key={index} value={offerInclusion.id}>
                                                                {offerInclusion.inclusionDescription}
                                                            </option>
                                                        )) : null
                                                }
                                            </Select>
                                            <FormHelperText>Hold the Ctrl Key to choose multiple inclusions</FormHelperText>
                                        </FormControl>
                                    </Grid>

                                    <Grid item sm={4} md={4} lg={4}>
                                        <TextField
                                            label={"Adults No."}
                                            fullWidth
                                            type={"number"}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <AccessibilityOutlinedIcon fontSize={"small"} />
                                                    </InputAdornment>
                                                ),
                                                inputProps: { min: 1 }
                                            }}
                                            required
                                        />
                                    </Grid>

                                    <Grid item sm={4} md={4} lg={4}>
                                        <TextField
                                            label={"Adult Price/Package (Single)"}
                                            fullWidth
                                            type={"number"}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <LocalAtmIcon fontSize={"small"} />
                                                    </InputAdornment>
                                                ),
                                                inputProps: { min: 0 }
                                            }}
                                            required
                                        />
                                    </Grid>

                                    <Grid item sm={4} md={4} lg={4}>
                                        <TextField
                                            label={"Adult Price/Package (Double)"}
                                            fullWidth
                                            type={"number"}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <LocalAtmIcon fontSize={"small"} />
                                                    </InputAdornment>
                                                ),
                                                inputProps: { min: 0 }
                                            }}
                                            required
                                        />
                                    </Grid>

                                    <Grid item sm={6} md={3} lg={3}>
                                        <TextField
                                            label={"Childs No."}
                                            fullWidth
                                            type={"number"}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <ChildCareOutlinedIcon fontSize={"small"} />
                                                    </InputAdornment>
                                                ),
                                                inputProps: { min: 0 }
                                            }}
                                        />
                                    </Grid>

                                    <Grid item sm={6} md={3} lg={3}>
                                        <TextField
                                            label={"Price/Child"}
                                            fullWidth
                                            type={"number"}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <LocalAtmIcon fontSize={"small"} />
                                                    </InputAdornment>
                                                ),
                                                inputProps: { min: 0 }
                                            }}
                                        />
                                    </Grid>

                                    <Grid item sm={6} md={3} lg={3}>
                                        <TextField
                                            label={"Infant No."}
                                            fullWidth
                                            type={"number"}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <ChildFriendlyOutlinedIcon fontSize={"small"} />
                                                    </InputAdornment>
                                                ),
                                                inputProps: { min: 0 }
                                            }}
                                        />
                                    </Grid>

                                    <Grid item sm={6} md={3} lg={3}>
                                        <TextField
                                            label={"Price/Infant"}
                                            fullWidth
                                            type={"number"}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <LocalAtmIcon fontSize={"small"} />
                                                    </InputAdornment>
                                                ),
                                                inputProps: { min: 0 }
                                            }}
                                        />
                                    </Grid>

                                    <Grid item sm={12} md={12} lg={12}>
                                        <TextField
                                            label="Inclusions Notes"
                                            multiline
                                            fullWidth
                                            required
                                            rows={3}
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid id="ex-pc" container item xs={12} spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography display="block" variant="subtitle2" gutterBottom>
                                            Exclusions Package
                                        </Typography>
                                    </Grid>

                                    <Grid item sm={12} md={6} lg={6}>
                                        <TextField
                                            label="Payment Policy"
                                            multiline
                                            fullWidth
                                            required
                                            rows={3}
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item sm={12} md={6} lg={6}>
                                        <TextField
                                            label="Cancellation Policy"
                                            multiline
                                            fullWidth
                                            required
                                            rows={3}
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item sm={12} md={6} lg={6}>
                                        <TextField
                                            label="Free Policy"
                                            multiline
                                            fullWidth
                                            required
                                            rows={3}
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item sm={6} md={4} lg={2}>
                                        <input
                                            accept="image/*"
                                            style={{ display: `none` }}
                                            id={`file-attach`}
                                            type="file"
                                        />
                                        <label htmlFor={`file-attach`}>
                                            <Button variant="outlined" color="primary" component="span">
                                                Attachment
                                        </Button>
                                        </label>
                                    </Grid>

                                    <Grid item sm={12} md={12} lg={12}>
                                        <TextField
                                            label="Exclusions Notes"
                                            multiline
                                            fullWidth
                                            required
                                            rows={3}
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12} spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        {
                                            error !== null ?
                                                <Alert variant="filled" severity="error">{error}</Alert>
                                                : null
                                        }
                                        {
                                            success === true ?
                                                <Alert variant="filled" severity="success">Offer Added Successfully</Alert>
                                                : null
                                        }
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12} spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            type="submit"
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                        >
                                            Submit Offer
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </>
                    :
                    <>
                        Standalone offer is not applicable Or you haven't added any category offer(flight offer, visa offer, ...)!!
                    </>
            }
        </>
    );
}

export default StandaloneOfferForm;